import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';
import { useGetWiseKycStatus } from 'src/core/modules/invoices/transfer/hooks';

export const useIsUkKycRejected = (enabled: boolean = true): boolean => {
  const company = useCompany();

  const hasUKInternationalTransferFeature = useFeature(
    FEATURES.TMP_UK_INTERNATIONAL_WIRE_TRANSFER,
  );

  const { data: kycStatus } = useGetWiseKycStatus({
    companyId: company.id,
    enabled:
      enabled &&
      company.currency === 'GBP' &&
      hasUKInternationalTransferFeature,
  });

  return kycStatus === 'REJECTED';
};
